'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);


var _RealtorLandingContactForm = require('./RealtorLandingContactForm.scss');var styles = _interopRequireWildcard(_RealtorLandingContactForm);

var _CompanyField = require('../../components/Company/CompanyContactUs/CompanyField/CompanyField');var _CompanyField2 = _interopRequireDefault(_CompanyField);
var _reduxFormValidators = require('../../helpers/reduxFormValidators');
var _components = require('../../components');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // styles
var
RealtorLandingContactFormComponent = function (_Component) {_inherits(RealtorLandingContactFormComponent, _Component);
  function RealtorLandingContactFormComponent(props) {_classCallCheck(this, RealtorLandingContactFormComponent);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.













































































































    realtorRegionOptions = ['center', 'north', 'south', 'Jerusalem'];_this.

    submitForm = function (values) {var
      name = values.name,email = values.email,phone_number = values.phone_number,message = values.message,realtor_region = values.realtor_region,company_name = values.company_name;var
      captcha = _this.state.captcha;
      var params = Object.assign({
        name: name,
        captcha: captcha,
        realtor_region: realtor_region && realtor_region.toString(),
        email: email && email.toLowerCase(),
        phone: phone_number,
        company_name: company_name,
        message: message },
      _this.props.userData && _this.props.userData.id ? { user_id: _this.props.userData.id } : {});

      _this.setState({ params: params });

      if (captcha) {
        _this.props.sendContactUsForm({
          data: params,
          isRealtor: true });

      }
    };_this.

    fetchReCaptchaToken = function (token) {
      _this.setState({ captcha: token }, _this.handleSubmit);
    };_this.

    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.submitForm)(evt);
      return true;
    };_this.

    renderOption = function (item) {return {
        id: item,
        label: '' + _this.props.translate('contactUsPage', 'userDetailsSection', item) };};_this.


    renderTextArea = function (_ref) {var input = _ref.input,placeholder = _ref.placeholder;return (
        _react2.default.createElement(_components.OMTextArea, _extends({
          placeholder: placeholder },
        input)));};_this.



    renderCheckbox = function (_ref2) {var input = _ref2.input;return (
        _react2.default.createElement(_components.OMMultiCheckbox, _extends({
          options: _this.realtorRegionOptions.map(_this.renderOption) },
        input)));};_this.state = { sending: false, params: {}, captcha: null };return _this;}RealtorLandingContactFormComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {var contactUs = _ref3.contactUs,isMessageModalOpen = _ref3.isMessageModalOpen;var stateModifier = {};var translate = this.props.translate('contactUsPage');if (contactUs.loading !== this.props.contactUs.loading) {stateModifier.sending = contactUs.loading;}if (contactUs.loaded && contactUs.loaded !== this.props.contactUs.loaded && this.state.params.email) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: styles.contentMessageWrapper }, _react2.default.createElement('div', { className: styles.contentMessage }, _react2.default.createElement('p', { className: styles.title }, translate('modalFeedback', 'title')), _react2.default.createElement('div', null, _react2.default.createElement('p', null, translate('modalFeedback', 'weWillContact')), _react2.default.createElement('p', null, translate('modalFeedback', 'messageNotification'))), _react2.default.createElement('button', { className: styles.primary, onClick: this.props.hideMessageModal }, translate('modalFeedback', 'textButton')))), isCloseButtonInvisible: true });this.props.handleRequest && this.props.handleRequest();}if (contactUs.loaded && contactUs.loaded !== this.props.contactUs.loaded && !this.state.params.email) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: styles.contentMessageWrapper }, _react2.default.createElement('div', { className: styles.contentMessage }, _react2.default.createElement('p', { className: styles.title }, translate('modalFeedback', 'title')), _react2.default.createElement('div', null, _react2.default.createElement('p', null, translate('modalFeedback', 'weWillContact')), _react2.default.createElement('p', null, translate('modalFeedback', 'notificationWithoutMessage'))), _react2.default.createElement('button', { className: styles.primary, onClick: this.props.hideMessageModal }, translate('modalFeedback', 'textButton')))), isCloseButtonInvisible: true });this.props.handleRequest && this.props.handleRequest();}if (contactUs.error && contactUs.error !== this.props.contactUs.error) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: styles.contentMessageError }, _react2.default.createElement('div', { className: 'contentMessage' }, _react2.default.createElement('div', null, _react2.default.createElement('p', null, translate('error')), _react2.default.createElement('button', { className: 'btn btn-primary', onClick: this.props.hideMessageModal }, translate('ok'))))) });this.props.handleRequest && this.props.handleRequest();}if (!isMessageModalOpen && contactUs.loaded && this.props.isMessageModalOpen) {this.props.reset();_reactRouter.browserHistory.push((0, _appendLocale2.default)(this.props.locale, '/'));}if (Object.keys(stateModifier).length) {this.setState(stateModifier);}};RealtorLandingContactFormComponent.prototype.



  render = function render() {var _cx;var _props =
    this.props,translate = _props.translate,isPublishForm = _props.isPublishForm;
    var contactUsTranslate = translate('contactUsPage', 'userDetailsSection');

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.wrapper, (_cx = {}, _cx[styles.modal] = this.props.inModal, _cx)) },
        _react2.default.createElement('div', { className: styles.titleWripper },
          _react2.default.createElement('p', { className: styles.title },
            contactUsTranslate(isPublishForm ? 'publishTitle' : 'title')),

          _react2.default.createElement('p', null,
            contactUsTranslate(isPublishForm ? 'publishTitleInfo' : 'titleInfo'))),


        _react2.default.createElement('form', null,
          _react2.default.createElement('div', { className: styles.infoBlock },
            _react2.default.createElement('div', { className: styles.columnInputs },
              _react2.default.createElement('div', { className: styles.inputWrapper },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'name',
                  component: _CompanyField2.default,
                  type: 'text',
                  validate: [_reduxFormValidators.required],
                  placeholder: contactUsTranslate('nameTitle') + ' *',
                  translateForError: translate('errorFieldMessages'),
                  isRtl: this.props.isRtl })),


              _react2.default.createElement('div', { className: styles.inputWrapper },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'phone_number',
                  component: _CompanyField2.default,
                  type: 'text',
                  validate: [_reduxFormValidators.required],
                  placeholder: contactUsTranslate('phoneTitle') + ' *',
                  translateForError: translate('errorFieldMessages'),
                  isRtl: this.props.isRtl })),


              _react2.default.createElement('div', { className: styles.inputWrapper },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'email',
                  component: _CompanyField2.default,
                  type: 'text',
                  placeholder: contactUsTranslate('emailTitle'),
                  translateForError: translate('errorFieldMessages'),
                  isRtl: this.props.isRtl })))),




          _react2.default.createElement('div', { className: styles.additionalBlock },
            _react2.default.createElement('div', { className: styles.companyName },
              _react2.default.createElement('div', { className: styles.label },
                _react2.default.createElement('span', null, contactUsTranslate('companyName'))),

              _react2.default.createElement(_reduxForm.Field, {
                name: 'company_name',
                component: _CompanyField2.default,
                type: 'text',
                placeholder: contactUsTranslate('companyName'),
                translateForError: translate('errorFieldMessages'),
                isRtl: this.props.isRtl })),


            !isPublishForm &&
            _react2.default.createElement('div', { className: styles.inputMessage },
              _react2.default.createElement('div', { className: styles.label }, translate('contactUsPage', 'messageSection', 'messageTitle')),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'message',
                component: this.renderTextArea,
                type: 'text',
                placeholder: translate('contactUsPage', 'messageSection', 'messageTitle'),
                translateForError: translate('errorFieldMessages'),
                isRtl: this.props.isRtl })),



            !isPublishForm &&
            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.checkboxWrapper, styles.checkBoxWrap) },
              _react2.default.createElement('div', { className: styles.label }, contactUsTranslate('realtorRegion')),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'realtor_region',
                component: this.renderCheckbox,
                translateForError: translate('errorFieldMessages'),
                isRtl: this.props.isRtl }))),




          _react2.default.createElement('div', { className: styles.submitWrapper },
            _react2.default.createElement('div', { className: styles.submitNotification },
              _react2.default.createElement('p', null,
                this.props.translate('contactUsPage', 'messageSection', 'submitNotification'))),


            _react2.default.createElement('div', { className: styles.submitBlock },
              _react2.default.createElement(_components.GoogleReCaptcha, {
                  locale: this.props.locale,
                  fetchToken: this.fetchReCaptchaToken,
                  doReset: this.props.contactUs.loaded },

                _react2.default.createElement(_components.OMButtonWithPreloader, {
                  showPreloader: this.state.sending,
                  className: 'contactUsForm',
                  innerText: this.props.translate('contactUsPage', 'messageSection', 'submitForDetails') })))))));







  };return RealtorLandingContactFormComponent;}(_react.Component);


RealtorLandingContactFormComponent.propTypes = {
  inModal: _propTypes2.default.bool,
  handleRequest: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  change: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  sendContactUsForm: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  userData: _propTypes2.default.object,
  contactUs: _propTypes2.default.object,
  isMessageModalOpen: _propTypes2.default.bool,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  isPublishForm: _propTypes2.default.bool };exports.default =


RealtorLandingContactFormComponent;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorLandingContactForm/RealtorLandingContactFormComponent.js
// module id = 1250
// module chunks = 0